import React from 'react'
import styled from 'styled-components'
import { Modal, Carousel } from 'react-bootstrap'
import { CoinComponent } from '../Gamification/CoinComponent'

const StyledModal = styled(Modal)`
  .modal-content {
    background: transparent;
    border: none;
  }
  h5 {
    background-color: #fff;
    text-align: center;
    padding: 24px;
    border-radius: 20px;
  }
  .carousel-control-next, 
  .carousel-control-prev {
    opacity: 1;
  }
  .carousel-control-prev {
    left: -10%;
  } 
  .carousel-control-next {
    right: -10%;
  }
  /* span.carousel-control-next-icon, span.carousel-control-prev-icon {
    background-color: #F83636;
    padding: 12px;
    border: 4px solid #F83636;
    border-radius: 4px;
  } */
`

export default function PosterModal({ mission, galleryType, images, posterOpen, setPosterOpen }) {
  return (
    <StyledModal
      show={posterOpen}
      onHide={()=>setPosterOpen(false)}
      aria-labelledby="images-modal"
      centered
      size={galleryType === "wallpaper" ? "lg" : "md"}
    > 
      { (galleryType === "wallpaper" && mission.mission_type === "image_gallery") && <CoinComponent mission={mission} />}
      <Modal.Body>
        {images.length > 0 ?
          images.length > 1 ?
          <Carousel>
            {images.map((poster,index)=>(
              <Carousel.Item key={`poster-${index}`} interval={4000}>
                <img className="d-block" src={poster.url} alt={`poster-${index}`} width="100%" />
              </Carousel.Item>
            ))}
          </Carousel>
          :
          <img className="d-block w-100" src={images[0].url} alt="poster" />
          :
          <h5>No poster available.</h5>
        }
      </Modal.Body>
    </StyledModal>
  )
}
